class TelInput extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.input = this.querySelector("input");
    this.init();
    this.validation();
  }

  init() {
  
    // Initialiser intl-tel-input
    this.iti = window.intlTelInput(this.input, {
      initialCountry: "fr",
      utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.13/js/utils.js"
    });
  
    // Validation et format du numéro
    this.input.addEventListener('change', () =>
      this.checkInputValidation(),
    );
  }

  checkInputValidation() {
    console.log("this.input : ", this.input.value);
    console.log("this.iti : ", this.iti.a.value == "");
    console.log("input value : ", this.input.value);
    if (!this.iti.isValidNumber() && !this.input.classList.contains('error')) {
      this.showError();
    } else {
      this.hideError();
    }
  }

  showError() {
    this.input.classList.add("error");
    this.classList.add("error");
  }

  hideError(){
    this.input.classList.remove("error");
    this.classList.remove("error");
  }

  validation() {
    this.closest('form').addEventListener('submit', function(event) {    
      if (!this.iti.isValidNumber()) {
        event.preventDefault();
        this.showError();
      }
    });      
  }
}

if(!customElements.get('tel-input')){
  customElements.define('tel-input', TelInput);
}